
import { WorldCountry } from '../types';
import { philippinesExpanded2 } from './philippinesExpansion2';

export const philippinesExpansion3: WorldCountry[] = [
  philippinesExpanded2
];
